"use strict";

var Modal = function () {

  var handleModal = function (layer, show) {
    const body = document.querySelector('body');
    const modal = document.querySelector(layer);

    if (show) {
      modal.classList.remove('opacity-0');
      modal.classList.remove('pointer-events-none');
      body.classList.add('modal-active');
    } else {
      modal.classList.add('opacity-0');
      modal.classList.add('pointer-events-none');
      body.classList.remove('modal-active');
    }
  };

  return {
    actions: function(layer) {
      handleModal(layer, true);
    },
    show: function(layer) {
      handleModal(layer, true);
    },
    hide: function(layer) {
      handleModal(layer, false);
    }
  };

}();

// webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Modal;
}